export default
    {
        catName: "fod",
        sucategories: [
            {
                id: "reci",
                name_ro: "GUSTARI RECI",
                name_eng: "COLD STARTERS",
                prod: [
                    {
                        name_ro: "PLATOU DE SALATE",
                        name_eng: "SALAD PLATTER",
                        gramaj: "600 g",
                        desc_ro: "Salata de boeuf, salata de icre de crap, fasole batuta, ardei copti, zacusca, salata de vinete, crema de branza condimentata",
                        desc_eng: "Romanian boeuf salad, carp roe spread, mashed butter beans, roasted peppers, zacusca, eggplant salad, spicy cream chees",
                        alergeni: "lactate, ou, peste, gluten / dairy, egg, fish, gluten",
                        pers_ro: "pentru 2 - 3 pers.",
                        pers_eng: "2 pax",
                        price: 63
                    },
                    {
                        name_ro: "PLATOU DE BRANZETURI",
                        name_eng: "CHEESE PLATTER",
                        gramaj: "500 g",
                        desc_ro: "Telemea de vaca, branza de burduf, selectie de branzeturi maturate, cruditati",
                        desc_eng: "Cow cheese, sheep cheese, selection of aged cheeses, fresh vegetables",
                        alergeni: "lactate / dairy",
                        pers_ro: "pentru 2 - 3 pers.",
                        pers_eng: "2 - 3 pax",
                        price: 68
                    },
                    {
                        name_ro: "SALATA DE BOEUF CU MURATURI DE CASA",
                        name_eng: "TRADITIONAL ROMANIAN BOEUF SALAD WITH HOMEMADE PICKLES",
                        gramaj: "200 g",
                        alergeni: "ou, lactate, mustar / egg, dairy, mustard",
                        price: 22
                    },
                    {
                        name_ro: "FASOLEA BATUTA A OSTEANULUI",
                        name_eng: "SOLDIER’S MASHED BUTTER BEANS",
                        gramaj: "150 g",
                        price: 18
                    },
                    {
                        name_ro: "SALATA DE VINETE BOIEREASCA",
                        name_eng: "BOYAR'S EGGPLANT SALAD",
                        gramaj: "200 g",
                        price: 18
                    },
                    {
                        name_ro: "SALATA DE ICRE DE CRAP",
                        name_eng: "CARP ROE SPREAD",
                        gramaj: "100 g",
                        alergeni: "peste / fish",
                        price: 21
                    },
                    {
                        name_ro: "ZACUSCA DE CASA",
                        name_eng: "ZACUSCA, homemade traditional spread",
                        gramaj: "150 g",
                        price: 18
                    },
                    {
                        name_ro: "SALATA DE PUI „PREFERATA HAREMULUI“",
                        name_eng: "'HAREM’S FAVORITE' CHICKEN SALAD",
                        desc_ro: "Ardei gras, castraveti, rosii, salata iceberg, piept de pui, sos de branza",
                        desc_eng: "Bell peppers, green cucumbers, tomatoes, iceberg lettuce, chicken breast, cheese sauce",
                        gramaj: "300 g",
                        alergeni: "lactate / dairy",
                        price: 29
                    },
                    {
                        name_ro: "SALATA BOIERULUI CU BRANZA FRIPTA",
                        name_eng: "BOYAR'S GRILLED CHEESE SALAD",
                        desc_ro: "Rosii, castraveti, ardei gras, ceapa, masline, telemea fripta",
                        desc_eng: "Tomatoes, green cucumbers, bell peppers, onion, olives, grilled cow cheese",
                        gramaj: "330 g",
                        alergeni: "lactate, gluten / dairy, gluten",
                        price: 29
                    },
                ]
            },
            {
                id: "calde",
                name_ro: "GUSTARI CLADE",
                name_eng: "HOT APPETIZERS",
                prod: [
                    {
                        name_ro: "PLATOU CALD",
                        name_eng: "HOT PLATTER",
                        gramaj: "600 g",
                        desc_ro: "Chiftelute, cascaval pane, ficatei de pui, carnati, pui pane, muraturi asortate, fudulii de curcan",
                        desc_eng: "Meatballs, breaded cheese, chicken livers, sausages, breaded chicken strips, pickles mix, turkey’s pride",
                        alergeni: "ou, gluten, susan / egg, gluten, sesame",
                        pers_ro: "2 - 3 pers.",
                        pers_eng: "2 - 3 pax",
                        price: 69
                    },
                    {
                        name_ro: "BULZ BOIERESC",
                        name_eng: "BOYAR'S BULZ",
                        gramaj: "300 g",
                        desc_eng: "Polenta with sour cream, salty cheeses and fried egg",
                        alergeni: "lactate, ou, peste, gluten / dairy, egg, fish, gluten",
                        price: 26
                    },
                    {
                        name_ro: "FICATEI DE PUI LA TIGAIE CU USTUROI, LEAC DE MOROI",
                        name_eng: "FRIED CHICKEN LIVERS WITH GARLIC, 'UNDEAD’S NIGHTMARE'",
                        gramaj: "250 g",
                        price: 26
                    },
                    {
                        name_ro: "JUMARI DE PUI „RASFATUL DOMNITEI“ ",
                        name_eng: "CHICKEN CRACKLINGS 'SPOILED PRINCESS’ DELIGHT'",
                        gramaj: "250 g",
                        price: 29
                    },
                    {
                        name_ro: "CASCAVAL RUMENIT IN CRUSTA DE POSMAGI",
                        name_eng: "FRIED BREADED CHEESE, PILIGRIM’S SNACK",
                        gramaj: "200 g",
                        alergeni: "gluten, lactate, ou / gluten, dairy, egg",
                        price: 27
                    },
                    {
                        name_ro: "CHIFTELUTE TRADITIONALE",
                        name_eng: "TRADITIONAL ROMANIAN MEATBALLS",
                        gramaj: "250 g",
                        alergeni: "gluten, ou / gluten, egg",
                        price: 28
                    },
                    {
                        name_ro: "DOVLECEI PRAJITI",
                        name_eng: "FRIED ZUCCHINI",
                        gramaj: "250 g",
                        alergeni: "gluten",
                        price: 20
                    },
                ]

            },
            {
                id: "ciorbe si supe",
                name_ro: "CIORBE SI SUPE",
                name_eng: "SOUPS",
                prod: [
                    {
                        name_ro: "CIORBA DE BURTA",
                        name_eng: "TRAVELER’S TRIPE SOUR SOUP",
                        gramaj: "350 g",
                        alergeni: "ou, lactate, telina / egg, dairy, gluten",
                        price: 19,
                    },
                    {
                        name_ro: "CIORBA TARANEASCA DE VACUTA",
                        name_eng: "TRADITIONAL PEASANT’S BEEF SOUR SOUP",
                        gramaj: "550 g",
                        alergeni: "telina, lactate / celery, dairy",
                        price: 18,
                    },
                    {
                        name_ro: "CIORBA DE FASOLE CU CIOLAN AFUMAT (servita în paine) ",
                        name_eng: "WHITE BEANS SOUP WITH SMOKED PORK (served in bread, as in medieval times)",
                        gramaj: "600 g",
                        alergeni: "telina, gluten / celery, gluten",
                        price: 19,
                    },
                    {
                        name_ro: "CIORBA TARANEASCA DE COCOS",
                        name_eng: "TRADITIONAL PEASANT’S ROOSTER SOUR SOUP",
                        gramaj: "350 g",
                        alergeni: "ou, telina / egg, celery",
                        price: 16,
                    },


                ]

            },
            {
                id: "peste",
                name_ro: "PESTE",
                name_eng: "FISH",
                prod: [
                    {
                        name_ro: "SARAMURA DE CRAP CU MAMALIGUTA",
                        name_eng: "FISHERMAN’S CARP IN BRINE, WITH VEGETABLES AND POLENTA",
                        gramaj: "600 g",
                        alergeni: "peste / fish",
                        price: 42,
                    },
                    {
                        name_ro: "CRAP ROMANESC CU MAMALIGUTA SI MUJDEI",
                        name_eng: "ROMANIAN CARP WITH POLENTA AND GARLIC SAUCE",
                        gramaj: "300 g",
                        alergeni: "gluten, ou, peste / gluten, egg, fish",
                        price: 37,
                    },
                    {
                        name_ro: "CALCAN PRAJIT IN CRUSTA DE MALAI",
                        name_eng: "CRISPY CORNMEAL FRIED TURBOT",
                        gramaj: "300 g",
                        alergeni: "gluten, ou, peste / gluten, egg, fish",
                        price: 73,
                    },
                    {
                        name_ro: "PASTRAV LA GRATAR „RASPLATA PESCARULUI“",
                        name_eng: "GRILLED TROUT 'FISHERMAN’S REWARD'",
                        gramaj: "300 g",
                        alergeni: "peste / fish",
                        price: 36,
                    },
                ]

            },
            {
                id: "preparate din carne",
                name_ro: "PREPARATE DIN CARNE",
                name_eng: "MEAT DISHES",
                prod: [
                    {
                        name_ro: "SNITEL DE PUI „PACATUL SULTANULUI“ ",
                        name_eng: "CHICKEN SCHNITZEL 'SULTAN’S SINFUL DESIRE'",
                        gramaj: "300 g",
                        alergeni: "gluten, oua / gluten, egg",
                        price: 32,
                    },
                    {
                        name_ro: "PUI ROMANESC LA CEAUN CU MUJDEI DE USTUROI",
                        name_eng: "KETTLE FRIED CHICKEN WITH GARLIC SAUCE",
                        gramaj: "400 g",
                        price: 36,
                    },
                    {
                        name_ro: "CARNE SI CARNATI IN UNTURA, ADAPOSTITE IN CAMARA CURTII",
                        name_eng: "FRIED HOMEMADE MEAT AND SAUSAGES IN LARD, SHELTERED IN CASTLE’S PANTRY",
                        gramaj: "300 g / 150 g",
                        price: 38,
                    },
                ]

            },
            {
                id: "gratar",
                name_ro: "GRATAR",
                name_eng: "GRILL",
                prod: [
                    {
                        name_ro: "CEAFA DE PORC „FESTINUL CRESTINILOR“",
                        name_eng: "PORK NECK 'CHRISTIANS' FEAST'",
                        gramaj: "250 g",
                        price: 32,
                    },
                    {
                        name_ro: "MUSCHIULET DE PORC „DARUL REGILOR“ ",
                        name_eng: "PORK SIRLOIN 'THE GIFT OF KINGS'",
                        gramaj: "250 g",
                        price: 32,
                    },
                    {
                        name_ro: "MICI ROMANESTI CA LA CURTEA SULTANULUI",
                        name_eng: "OTTOMAN COURT MITITEI SAUSAGES",
                        gramaj: "70 g / buc",
                        gramaj_eng: "70 g / piece",
                        alergeni: "mustar / mustard",
                        price: 6,
                    },
                    {
                        name_ro: "SELECTIE DE CARNATI PROASPETI ",
                        name_eng: "HOMEMADE FRESH SAUSAGES SELECTION",
                        gramaj: "250 g",
                        price: 31,
                    },
                    {
                        name_ro: "COTLETE DE BERBECUT CU OS „CONSTANTINOPOLE“ ",
                        name_eng: "'CONSTANTINOPLE' LAMP CHOPS",
                        gramaj: "250 g",
                        price: 67,
                    },
                    {
                        name_ro: "PIEPT DE RATA FRANTUZIT LA FOC REPEDE ",
                        name_eng: "QUICK GRILLED DUCK BREAST",
                        gramaj: "200 g",
                        price: 59,
                    },
                    {
                        name_ro: "ARIPIOARE DE PUI PICANTE LA TEPUSE",
                        name_eng: "IMPALED SPICY CHICKEN WINGS",
                        gramaj: "300 g",
                        price: 29,
                    },
                    {
                        name_ro: "PULPE DE PUI DEZOSATE INABUSITE IN JAR",
                        name_eng: "BONELESS CHICKEN LEGS BRAISED ON HOT EMBERS",
                        gramaj: "250 g",
                        price: 28,
                    },
                    {
                        name_ro: "PIEPT DE PUI PEDEPSIT PE JARATEC",
                        name_eng: "GRILLED CHICKEN BREAST",
                        gramaj: "250 g",
                        price: 29,
                    },
                    {
                        name_ro: "MUSCHI DE VITA „DEZMIERDAREA JUPANILOR“ ",
                        name_eng: "BEEF SIRLOIN 'PATRON’S DELIGHT'",
                        gramaj: "250 g",
                        price: 79,
                    },
                    {
                        name_ro: "ANTRICOT DE VITA ",
                        name_eng: "THE TRUE BEEF STEAK",
                        gramaj: "600 g",
                        price: 82,
                    },
                    {
                        name_ro: "PASTRAMA DE BERBECUT OTOMANA CU MAMALIGA NEAOSA",
                        name_eng: "OTTOMAN LAMB PASTRAMI WITH LOCAL POLENTA",
                        gramaj: "250 g / 150 g",
                        price: 53,
                    },
                    {
                        name_ro: "PLATOU CU CARNE ",
                        name_eng: "MEAT PLATTER ",
                        gramaj: " 600 g / 150 g",
                        desc_ro: "Carnati proaspeti, ceafa de porc, mici, pastrama de berbecut, pulpe de pui, cartofi prajiti",
                        desc_eng: "Fresh sausages, pig neck, mici, lamb pastrami, chicken legs, french fries",
                        alergeni: "mustar / mustard",
                        pers_ro: "2 pers.",
                        pers_eng: "2 pax",
                        price: 78,
                    },
                ]
            },
            {
                id: "salate",
                name_ro: "SALATE",
                name_eng: "SALADS",
                prod: [
                    {
                        name_ro: "SALATA DE VARZA",
                        name_eng: "FRESH CABBAGE SALAD",
                        gramaj: "150 g",
                        price: 12,
                    },
                    {
                        name_ro: "SALATA DE ARDEI COPTI",
                        name_eng: "ROASTED PEPPER SALAD",
                        gramaj: "150 g",
                        price: 17,
                    },
                    {
                        name_ro: "SALATA DE MURATURI",
                        name_eng: "PICKLES ASSORTMENT",
                        gramaj: "200 g",
                        price: 15,
                    },
                    {
                        name_ro: "SALATA VERDE CU LAMAIE",
                        name_eng: "ICEBERG SALAD WITH FRESH LEMON",
                        gramaj: "150 g",
                        price: 13,
                    },
                    {
                        name_ro: "SALATA DE SFECLA CU HREAN",
                        name_eng: "HORSERADISH SPICED BEETROOT SALAD",
                        gramaj: "150 g",
                        price: 13,
                    },
                    {
                        name_ro: "SALATA DE VARA",
                        name_eng: "SUMMER SALAD",
                        gramaj: "200 g",
                        price: 15,
                    },

                ]

            },
            {
                id: "garnituri",
                name_ro: "GARNITURI",
                name_eng: "SIDE DISHES",
                prod: [
                    {
                        name_ro: "CARTOFI PRAJITI",
                        name_eng: "FRENCH FRIES",
                        gramaj: "150 g",
                        price: 9,
                    },
                    {
                        name_ro: "CARTOFI LA CEAUN",
                        name_eng: "KETTLE FRIED POTATOES",
                        gramaj: "150 g",
                        price: 9,
                    },
                    {
                        name_ro: "CARTOFI TARANESTI",
                        name_eng: "TRADITIONAL PEASANT’S KETTLE FRIED POTATOES",
                        gramaj: "200 g",
                        price: 14,
                    },
                    {
                        name_ro: "VARZA CALITA",
                        name_eng: "FRIED SAUERKRAUT",
                        gramaj: "200 g",
                        price: 14,
                    },
                    {
                        name_ro: "IAHNIE DE FASOLE ",
                        name_eng: "WHITE BEANS STEW",
                        gramaj: "200 g",
                        price: 13,
                    },
                    {
                        name_ro: "OREZ BASMATI CU LEGUME ",
                        name_eng: "BASMATI RICE WITH VEGETABLES",
                        gramaj: "150 g",
                        alergeni: "telina / celery",
                        price: 12,
                    },
                    {
                        name_ro: "CIUPERCI LA GRATAR ",
                        name_eng: "GRILLED MUSHROOMS",
                        gramaj: "150 g",
                        price: 15,
                    },
                    {
                        name_ro: "LEGUME LA GRATAR ",
                        name_eng: "GRILLED VEGETABLES",
                        gramaj: "150 g",
                        price: 15,
                    },
                    {
                        name_ro: "MAMALIGUTA",
                        name_eng: "TRADITIONAL POLENTA",
                        gramaj: "150 g",
                        price: 6,
                    },
                    {
                        name_ro: "CIUPERCI SOTE",
                        name_eng: "SAUTEED MUSHROOMS",
                        gramaj: "200 g",
                        price: 15,
                    },
                ]

            },
            {
                id: "dulciuri",
                name_ro: "DULCIURI",
                name_eng: "DESSERTS",
                prod: [
                    {
                        name_ro: "PAPANASI „CRAMA DOMNEASCA“",
                        name_eng: "HOMEMADE CHEESE DUMPLINGS",
                        alergeni: "lactate, ou, gluten / dairy, egg, gluten",
                        gramaj: "200 g",
                        price: 19,
                    },
                    {
                        name_ro: "PLACINTA CU BRANZA",
                        name_eng: "CHEESE PIE",
                        alergeni: "lactate, ou, gluten / dairy, egg, gluten",
                        gramaj: "150 g",
                        price: 16,
                    },
                    {
                        name_ro: "PLACINTA CU MERE",
                        name_eng: "APPLE PIE",
                        alergeni: "ou, gluten / egg, gluten",
                        gramaj: "150 g",
                        price: 16,
                    },
                    {
                        name_ro: "CLATITE CU DULCEATA / CIOCOLATA",
                        name_eng: "ROLLED PANCAKES WITH JAM / CHOCOLATE FILLING",
                        alergeni: "lactate, ou, gluten / dairy, egg, gluten",
                        gramaj: "175 g",
                        price: 16,
                    },
                    {
                        name_ro: "TORT DE BISCUITI",
                        name_eng: "BISCUITS CAKE",
                        alergeni: "lactate, ou, gluten / dairy, egg, gluten",
                        gramaj: "175 g",
                        price: 17,
                    },
                    {
                        name_ro: "ÎNGHETATA (3 cupe)",
                        name_eng: "ICE CREAM",
                        alergeni: "lactate, ou / dairy, egg",
                        gramaj: "150 g",
                        price: 19,
                    },
                    {
                        name_ro: "PRUNE USCATE UMPLUTE CU NUCI, IN SOS DE VIN ROSU",
                        name_eng: "SMOKED PRUNES STUFFED WITH WALNUTS, IN RED WINE SAUCE",
                        alergeni: "nuci / walnuts",
                        gramaj: "120 g",
                        price: 19,
                    },
                ]

            }
        ],
        options: {
            showCatTabs: true
        }
    }

